import { useSelector } from 'react-redux';

import { useAuth } from 'contexts/auth';
import { APP_V1_BASEURL } from 'lib/urls';

import type { RootState } from 'store/store.types';

// The v1 Rails page where company admins approve or deny account-recovery requests. Users ask for
// recovery from the sign-in page when they lose access to their 2FA device or passkey.
export const RECOVERY_REQUESTS_URL = `${APP_V1_BASEURL}/account/recovery_requests`;

/**
 * Returns how many account-recovery requests wait for an admin's answer, from the counts that
 * the notifications poller stores in Redux. Returns 0 for anyone who is not an admin, because
 * only admins can open RECOVERY_REQUESTS_URL.
 */
export function usePendingRecoveryRequests(): number {
  const { isAdmin } = useAuth();

  const pendingRecoveryCount = useSelector<RootState, number>(
    (state) =>
      state.auth?.notificationsCounts?.pendingRecoveryRequestsCount ?? 0,
  );

  return isAdmin ? pendingRecoveryCount : 0;
}
